// export const Document_Type = [

import { TFunction } from 'i18next'

// ]
export const documentTypeMap = (t: TFunction, type: string): string => {
    switch (type) {
        case 'POLICY':
            return t('document.type.policy')
        case 'GUIDELINE':
            return t('document.type.guideline')
        case 'NOTIFICATION':
            return t('document.type.notification')
        case 'INTERNAL_REGULATION':
            return t('document.type.internal_regulation')
        case 'REGULATION':
            return t('document.type.regulation')
        case 'FORM':
            return t('document.type.form')
        case 'OBJECTIVE':
            return t('document.type.objective')
        case 'PLAN':
            return t('document.type.plan')
        case 'REPORT':
            return t('document.type.report')
        case 'MINUTES':
            return t('document.type.minutes')
        case 'CONTRACT':
            return t('document.type.contract')
        case 'DECISION':
            return t('document.type.decision')
        case 'OTHER':
            return t('document.type.other')
        default:
            return ''
    }
}
export const documentLevelMap = (t: TFunction, level: string): string => {
    switch (level) {
        case 'CF':
            return t('document.level.cf')
        case 'LM':
            return t('document.level.lm')
        case 'IN':
            return t('document.level.in')
        default:
            return ''
    }
}
